"use strict";

exports.__esModule = true;
exports.filterNonBusinessLocations = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
const filterNonBusinessLocations = locations => locations.filter(location => location.type === _types.LocationType.BUSINESS);
exports.filterNonBusinessLocations = filterNonBusinessLocations;
//# sourceMappingURL=location.js.map